import { SvgIcon } from '@mui/material';

const ArrowLeftSmall = (props) => {
  return (
    <SvgIcon width="9" height="14" viewBox="0 0 9 14" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M0.237737 7.47518C-0.0219539 7.21252 -0.0219539 6.78816 0.237737 6.52482L6.40106 0.285008C6.77595 -0.0950026 7.38588 -0.0950026 7.76144 0.285008C8.13632 0.665018 8.13632 1.28177 7.76144 1.66178L2.48905 7.00034L7.76144 12.3375C8.13632 12.7182 8.13632 13.335 7.76144 13.715C7.38588 14.095 6.77595 14.095 6.40106 13.715L0.237737 7.47518Z"/>
    </SvgIcon>
  );
};

export default ArrowLeftSmall;